import { useMemo } from "react";
import { useNetwork } from "wagmi";
import config from "../config";

export default function useCurrentChain() {
  const network = useNetwork();
  return useMemo(() => {
    return network.chain && !network.chain.unsupported
      ? network.chain
      : config.chains[0];
  }, [network.chain]);
}
